import {createContext} from 'react';

export const TemaContext = createContext();

